import {ListSortOrder} from "@model";

export class Sort {
  private sortOrder: number = 1;
  private collator: Intl.Collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: "base",
  });

  constructor() {

  }

  public startSort(properties?: any[], order?: string, type: string = "") {
    if (order === ListSortOrder.DESC) {
      this.sortOrder = -1
    }
    return (a: any, b: any): number => {
      let result = 0;
      let aAll = "";
      let bAll = "";
      if (properties) {
        properties.forEach(property => {

          const aValue = this.getObjectPropertyValue(a, property);
          const bValue = this.getObjectPropertyValue(b, property);
          if (type === "date") {
            result = this.sortData(new Date(aValue), new Date(bValue));
          } else {
            aAll += " " + aValue;
            bAll += " " + bValue;
            if (properties.indexOf(property) === properties.length - 1) {
              result = this.collator.compare(aAll.substring(1), bAll.substring(1)) * this.sortOrder;
            } else {
              result = this.collator.compare(aValue, bValue) * this.sortOrder;
            }
          }
        })
        return result;
      } else {
        return 0;
      }
    }
  }

  private sortData(a: any, b: any) {
    if (a < b) {
      return -1 * this.sortOrder;
    } else if (a > b) {
      return this.sortOrder;
    } else {
      return 0;
    }
  }

  public static sortByOrder(listToSort: any[], orderList: any[]): any[] {
    return listToSort.sort((a, b) => {
      const indexA: number = orderList.indexOf(a);
      const indexB: number = orderList.indexOf(b);

      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }

      if (indexA !== -1) {
        return -1;
      } else if (indexB !== -1) {
        return 1;
      }
      return 0;
    });
  }

  private getObjectPropertyValue(obj: any, propertyPath: string): any {
    const pathSegments = propertyPath.split('.');
    let value = obj;
    for (const segment of pathSegments) {
      if (value && value.hasOwnProperty(segment)) {
        value = value[segment];
      } else {
        return undefined; // Property path doesn't exist
      }
    }
    return value;
  }

}
